module.exports = __webpack_public_path__ + "static/casumo-83512aa59baa3ba9947f4e8b4a7878af.png";